import { log } from 'log';
import { pick } from 'ramda';
import { useCallback } from 'react';
import { useDeviceSelector, useUserSelector } from 'js/store/hooks';

import * as helpers from './helpers';
import { ISliderOptions } from '../../types';
import { useFetchBannerFeed } from '../useFetchBannerFeed';

export const useGetSlides = () => {
    const fetchBannerFeed = useFetchBannerFeed();
    const { formFactor, os, browserName } = useDeviceSelector(pick(['formFactor', 'os', 'browserName']));
    const { isLoggedIn, lang, urlTemplates, country } = useUserSelector(pick(['isLoggedIn', 'lang', 'urlTemplates', 'country']));

    return useCallback(async () => {
        try {
            const bannerFeed = await fetchBannerFeed();
            const sliderOptions = helpers.getSliderOptions({ bannerFeed, formFactor });
            const playerTags = await helpers.getSliderPlayerTags({ bannerFeed, isLoggedIn });
            const slides = helpers.getSlides({
                bannerFeed,
                options: {
                    os,
                    isLoggedIn,
                    formFactor,
                    playerTags,
                    browserName,
                    userLanguage: lang,
                    userCountry: country,
                    segmentationURLTemplates: urlTemplates
                }
            });

            return { sliderOptions, slides };
        } catch (error) {
            log('error', error);

            return { sliderOptions: {} as ISliderOptions, slides: [] };
        }
    }, [os, lang, country, isLoggedIn, formFactor, browserName, urlTemplates, fetchBannerFeed]);
};
